/*
 * @Author: cn1994
 * @Date: 2023-09-14 10:33:46
 * @LastEditors: cn1994
 * @LastEditTime: 2024-01-26 16:00:09
 * @Description: file content
 */
const routes = [
  //班级管理首页
  {
    path: "/groups",
    name: "groups",
    meta: {
      title: "班级管理",
      hasBack: false,
      volcengine: true,
    },
    component: () => import("../pages/educational/affairs.vue")
  },
  // 班级详情
  {
    path: "/groups/detail",
    name: "groups/detail",
    meta: {
      title: "班级详情",
      hasBack: true
    },
    component: () => import("../pages/educational/affairs/class/detail.vue")
  },
  {
    path: "/groups/courses/created",
    name: "groups/courses/created",
    meta: {
      title: "创建课程",
      hasBack: true
    },
    component: () => import("../pages/educational/courses/created")
  },
  // 班级课程详情
  {
    path: "/groups/classCoursesInfo",
    name: "groups/classCoursesInfo",
    meta: {
      title: "课程详情",
      hasBack: true
    },
    component: () => import("../pages/educational/affairs/class/detail/classCoursesInfo.vue")
  }
];

export default routes;
